import TealiumEventBuilder from '../../analytics/tealium/builders/tealium-event-builder';

const { clone, isEmpty } = require('lodash');

const merchantHostedStorageKey = 'pendingMerchantHostedLogic';

class FulfilmentSelectorDeliveryPickupController {
    constructor($rootScope, dialogRegistry, settings, addressService, fulfilmentService, fulfilmentSelectorService, analyticsService, sessionStorage) {
        this.$rootScope = $rootScope;
        this.dialogRegistry = dialogRegistry;
        this.settings = settings;
        this.addressService = addressService;
        this.fulfilmentService = fulfilmentService;
        this.fulfilmentSelectorService = fulfilmentSelectorService;
        this.analyticsService = analyticsService;
        this.sessionStorage = sessionStorage;
    }

    $onInit() {
        this.fulfilmentSelectorService.setModalTitleMessage(this.settings.fulfilmentSelector.fulfilmentMethodSelectorTitle);

        const existingfulfilmentMethodType = this.fulfilmentService.selectedFulfilmentMethod.type;

        // get the selectorFulfilmentOptions object based on existing method
        this.selectedFulfilmentMethod = this.fulfilmentSelectorService.getSelectorFulfilmentOption(existingfulfilmentMethodType);

        // update selectorFulfilmentOptions in service
        this.fulfilmentSelectorService.updateSelectorFulfilmentOptions(existingfulfilmentMethodType);

        if (this.fulfilmentSelectorService.isNotServiced) {
            if (!isEmpty(this.fulfilmentService.manualAddress)) {
                this.selectedDeliveryAddress = this.fulfilmentService.manualAddress;
            }
        } else if (!isEmpty(this.selectedFulfilmentMethod)) {
            if (this.isPickup()) {
                this.fulfilmentSelectorService.selectedPickupAddress = this.fulfilmentService.savedAddress;
            } else {
                this.fulfilmentSelectorService.selectedDeliveryAddress = this.fulfilmentService.savedAddress;
            }
        }

        this.addressService.getSavedAddresses().then(() => {
            this.savedAddresses = this.addressService.savedAddresses;
        });

        // keep previous values of address and fufilment method in case user submits empty address
        this.previouslySelectedAddress = clone(this.fulfilmentService.savedAddress);
        this.previouslySelectedFulfilmentMethod = clone(this.selectedFulfilmentMethod);
        this.addressEmptyError = false;
    }

    isPickup() {
        return !isEmpty(this.selectedFulfilmentMethod) ? this.selectedFulfilmentMethod.type === this.fulfilmentSelectorService.fulfilmentMethodPickupType : this.previouslySelectedFulfilmentMethod.type === this.fulfilmentSelectorService.fulfilmentMethodPickupType;
    }

    pickupAddressSelected(address) {
        this.fulfilmentSelectorService.selectedPickupAddress = address;
        this.updateAddressEmptyError();
    }

    deliveryAddressSelected(address) {
        this.fulfilmentSelectorService.selectedDeliveryAddress = address;
        if (!address || !address.AreaId) {
            this.fulfilmentSelectorService.isNotServiced = true;
            const event = new TealiumEventBuilder()
                .withScreenName('FulfilmentSelection')
                .withEventType(this.analyticsService.mapperTypes.shop.fulfilmentSelector.fulfilmentSelectorDialog)
                .withAction('click')
                .withLabel('Non serviced address')
                .withEventName('error')
                .withValue(`${this.tempAddress.Text}`)
                .withTrackingType('link')
                .build();
            this.analyticsService.push(event);
        } else {
            this.fulfilmentSelectorService.isNotServiced = false;
        }
    }

    onSaveAutoAddress(address) {
        this.tempAddress = address;
        return this.addressService.saveAutoAddress(address).then(response => this.deliveryAddressSelected(response.Address));
    }

    setFulfilmentMethod(fulfilmentMethod) {
        const event = new TealiumEventBuilder()
            .withScreenName('FulfilmentSelection')
            .withLabel('Fulfilment type toggle')
            .withValue(fulfilmentMethod.name === 'Delivery' ? 'Delivery' : 'Pickup')
            .withEventType(this.analyticsService.mapperTypes.shop.fulfilmentSelector.fulfilmentSelectorDialog)
            .withEventName('modal_interaction')
            .withTrackingType('link')
            .build();

        this.analyticsService.push(event);
        this.selectedFulfilmentMethod = fulfilmentMethod;
        this.fulfilmentSelectorService.updateSelectorFulfilmentOptions(fulfilmentMethod.type);

        if (this.addressEmptyError) {
            this.updateAddressEmptyError();
        }
        if (this.fulfilmentSelectorService.isNotServiced && isEmpty(this.fulfilmentSelectorService.selectedDeliveryAddress)) {
            this.fulfilmentSelectorService.isNotServiced = false;
        }
    }

    updateAddressEmptyError() {
        const address = this.isPickup() ? this.fulfilmentSelectorService.selectedPickupAddress : this.fulfilmentSelectorService.selectedDeliveryAddress;

        if (isEmpty(address)) {
            this.addressEmptyError = true;
        } else {
            this.addressEmptyError = false;
        }
    }

    saveFulfilment() {
        const event = new TealiumEventBuilder()
            .withScreenName('FulfilmentSelection')
            .withLabel('Button/link click')
            .withValue('Next')
            .withEventType(this.analyticsService.mapperTypes.shop.fulfilmentSelector.fulfilmentSelectorDialog)
            .withEventName('modal_interaction')
            .withTrackingType('link')
            .build();

        this.analyticsService.push(event);

        const address = this.isPickup() ? this.fulfilmentSelectorService.selectedPickupAddress : this.fulfilmentSelectorService.selectedDeliveryAddress;

        if (isEmpty(address)) {
            this.addressEmptyError = true;
            return;
        }

        this.addressEmptyError = false;

        if (!this.isPickup() && this.fulfilmentSelectorService.isNotServiced) {
            return;
        }

        const previousAddressId = this.previouslySelectedAddress && this.previouslySelectedAddress.AddressId;
        if (address.AddressId !== previousAddressId) {
            // save address for future use
            this.fulfilmentService.saveFulfilment({
                fulfilmentMethod: this.isPickup() ? 'Pickup' : 'Courier',
                address,
                fulfilmentWindow: { time: null },
                billingAddressId: null,
            }).then((response) => {
                if (response && response.IsNonServiced) {
                    this.fulfilmentSelectorService.isNotServiced = true;
                } else {
                    this.fulfilmentSelectorService.isNotServiced = false;

                    // set up fulfilment method and address for right hand panel
                    this.fulfilmentService.selectedFulfilmentMethod = this.isPickup()
                        ? this.fulfilmentService.fulfilmentOptions.pickup
                        : this.fulfilmentService.fulfilmentOptions.delivery;

                    this.fulfilmentService.savedAddress = address != null ? address : this.previouslySelectedAddress;

                    // Reset the time/date since they have confirmed a new selection.
                    this.fulfilmentService.reservedDate = null;
                    this.fulfilmentService.reservedTime = null;

                    this.saveFulfilmentSuccess();
                }
            });
        } else {
            this.saveFulfilmentSuccess();
        }
    }

    saveFulfilmentSuccess() {
        // switch to start shopping screen
        this.fulfilmentSelectorService.currentStep = this.fulfilmentSelectorService.fulfilmentSelectorSteps.startShopping;

        if (this.fulfilmentSelectorService.shouldEnableFulfilmentSelectorStartShopping) {
            this.fulfilmentSelectorService.setUserPreferenceFulfilmentSelectorStepStartShopping(true);
        }

        this.sessionStorage.set(merchantHostedStorageKey, true);
    }

    confirmLater() {
        const dialog = this.dialogRegistry.getDialog('fulfilment-selector-dialog');
        const event = new TealiumEventBuilder()
            .withScreenName('FulfilmentSelection')
            .withLabel('Button/link click')
            .withValue('Confirm later')
            .withEventName('modal_interaction')
            .withEventType(this.analyticsService.mapperTypes.shop.fulfilmentSelector.fulfilmentSelectorDialog)
            .withAction('click')
            .withTrackingType('link')
            .build();
        this.analyticsService.push(event);

        if (dialog) {
            this.$rootScope.$broadcast('FMS:close');
            dialog.close();
        }
    }

    onKeyPress($event, option) {
        if ($event && $event.keyCode === 13) {
            this.setFulfilmentMethod(option);

            event.preventDefault();
        }
    }
}

FulfilmentSelectorDeliveryPickupController.$inject = ['$rootScope', 'DialogRegistry', 'Settings', 'AddressService', 'FulfilmentService', 'FulfilmentSelectorService', 'AnalyticsService', 'SessionStorageWrapper'];

const fulfilmentSelectorDeliveryPickupComponentDefinition = {
    controller: FulfilmentSelectorDeliveryPickupController,
    template: require('./fulfilment-selector-delivery-pickup.component.html').trim(),
};

module.exports = {
    FulfilmentSelectorDeliveryPickupController,
    fulfilmentSelectorDeliveryPickupComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/fulfilment/fulfilmentselector/fulfilment-selector-delivery-pickup.component.js